import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label", "onKeydown"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "video-preview__play-button" }
const _hoisted_4 = { class: "video-preview__play-label typographies-paragraph-caps-small-bold" }
const _hoisted_5 = { class: "video-preview-modal__content" }
const _hoisted_6 = ["src", "title"]

import { ref, computed, nextTick, inject } from 'vue';
import { Translator } from 'js/shims-vue';

interface Props {
    thumbnailSrc: string;
    videoUrl: string;
    thumbnailAlt?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoPreview',
  props: {
    thumbnailSrc: {},
    videoUrl: {},
    thumbnailAlt: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    watch: $t.__('common.labels.watch'),
    close: $t.__('common.actions.close'),
};

const isModalOpen = ref(false);
const modalRef = ref<HTMLElement | null>(null);

const getEmbedUrl = (url: string): string => {
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)(?:\/([a-zA-Z0-9]+))?/);
    if (vimeoMatch) {
        const videoId = vimeoMatch[1];
        const hash = vimeoMatch[2];
        const hashParam = hash ? `?h=${hash}&autoplay=1` : '?autoplay=1';
        return `https://player.vimeo.com/video/${videoId}${hashParam}`;
    }
    const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (youtubeMatch) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
    }
    if (url.startsWith('https://')) {
        return url;
    }
    return '';
};

const embedUrl = computed((): string => {
    return getEmbedUrl(props.videoUrl);
});

const openModal = async (): Promise<void> => {
    isModalOpen.value = true;
    document.body.style.overflow = 'hidden';
    await nextTick();
    modalRef.value?.focus();
};

const closeModal = (): void => {
    isModalOpen.value = false;
    document.body.style.overflow = '';
};

return (_ctx: any,_cache: any) => {
  const _component_CompassIconButton = _resolveComponent("CompassIconButton")!
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "video-preview",
      role: "button",
      tabindex: "0",
      "aria-label": translations.watch,
      onClick: openModal,
      onKeydown: [
        _withKeys(openModal, ["enter"]),
        _withKeys(_withModifiers(openModal, ["prevent"]), ["space"])
      ]
    }, [
      _createElementVNode("img", {
        src: __props.thumbnailSrc,
        alt: __props.thumbnailAlt,
        class: "video-preview__thumbnail"
      }, null, 8 /* PROPS */, _hoisted_2),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "video-preview__overlay" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "video-preview__play-icon" }, [
          _createElementVNode("svg", {
            class: "video-preview__play-svg",
            viewBox: "0 0 21 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M20 11L0.5 21.5V0.5L20 11Z",
              fill: "currentColor"
            })
          ])
        ], -1 /* CACHED */)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(translations.watch), 1 /* TEXT */)
      ])
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "video-preview-fade" }, {
        default: _withCtx(() => [
          (isModalOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "modalRef",
                ref: modalRef,
                class: "video-preview-modal",
                tabindex: "-1",
                onClick: _withModifiers(closeModal, ["self"]),
                onKeydown: _withKeys(closeModal, ["esc"])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("iframe", {
                    src: embedUrl.value,
                    title: translations.watch,
                    class: "video-preview-modal__iframe",
                    allow: "autoplay; fullscreen",
                    allowfullscreen: ""
                  }, null, 8 /* PROPS */, _hoisted_6)
                ]),
                _createVNode(_component_CompassTooltip, {
                  content: translations.close,
                  placement: _ctx.CompassEnums.TooltipPosition.LEFT,
                  class: "video-preview-modal__tooltip",
                  "content-class": "video-preview-modal__tooltip-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CompassIconButton, {
                      icon: "close",
                      type: _ctx.CompassEnums.IconButtonType.SECONDARY,
                      variant: _ctx.CompassEnums.IconButtonVariant.CONTRAST,
                      onClick: closeModal
                    }, null, 8 /* PROPS */, ["type", "variant"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["content", "placement"])
              ], 544 /* NEED_HYDRATION, NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})